import React, { useEffect, useState } from "react";
import { useGetAllSolutionApi } from "../../hooks/solution/useGetAllSolutionApi";
import { Button, Input, Modal, Space, Table } from "antd";
import { useCreateSolutionApi } from "../../hooks/solution/useCreateSolutionApi";
import toast from "react-hot-toast";
import { useGetAllTypeTransactionApi } from "../../hooks/type-transaction/useGetAllTypeTransactionApi";
import { useCreateTypeTransactionApi } from "../../hooks/type-transaction/useCreateTypeTransactionApi";
import { useUpdateTypeTransactionApi } from "../../hooks/type-transaction/useUpdateTypeTransactionApi";
import { useDeleteTypeTransactionApi } from "../../hooks/type-transaction/useDeleteTypeTransactionApi";
import { FooterFilterMobile } from "../../components";
import { useAccountStore } from "../../store";
import { ROLE } from "../../ultils/constants";
import path from "../../ultils/path";
import { useNavigate } from "react-router-dom";

const TypeTransactionPage = () => {
  // state
  const [listTypeTransaction, setListTypeTransaction] = useState<any>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenUpdate, setIsModalOpenUpdate] = useState(false);
  const [type, setType] = useState<any>();
  const [infoUpdate, setInfoUpdate] = useState<any>();

  const navigate = useNavigate();
  const { info } = useAccountStore();
  useEffect(() => {
    if (!info || info?.role !== ROLE.ROLE_ADMIN) {
      navigate(path.SIGN_IN);
    }
  }, []);

  // api
  const { typeTransaction } = useGetAllTypeTransactionApi();
  const { mutate: $createNewTypeTransaction } = useCreateTypeTransactionApi();
  const { mutate: $updateNewTypeTransaction } = useUpdateTypeTransactionApi();
  const { mutate: $deleteTypeTransaction } = useDeleteTypeTransactionApi();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    $createNewTypeTransaction(
      {
        type,
      },
      {
        onSuccess: () => {
          toast.success("Create new Type Transaction success");
          setIsModalOpen(false);
          setType("");
          return;
        },
        onError: () => {
          toast.error("Create new Type Transaction failure");
          setIsModalOpen(false);
          setType("");
          return;
        },
      }
    );
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOkUpdate = async () => {
    $updateNewTypeTransaction(
      {
        type,
        id: infoUpdate?.id,
      },
      {
        onSuccess: () => {
          toast.success("Update Type Transaction success");
          setIsModalOpenUpdate(false);
          setType("");
          return;
        },
        onError: () => {
          toast.error("Update Type Transaction failure");
          setIsModalOpenUpdate(false);
          setType("");
          return;
        },
      }
    );
  };

  const handleDelete = async (id: any) => {
    $deleteTypeTransaction(
      {
        id,
      },
      {
        onSuccess: () => {
          toast.success("Delete Type Transaction success");
          setIsModalOpenUpdate(false);
          setType("");
          return;
        },
        onError: () => {
          toast.error("Delete Type Transaction failure");
          setIsModalOpenUpdate(false);
          setType("");
          return;
        },
      }
    );
  };

  const handleCancelUpdate = () => {
    setIsModalOpenUpdate(false);
  };

  useEffect(() => {
    if (typeTransaction) {
      const convertData = typeTransaction?.data?.map(
        (item: any, index: number) => {
          return {
            id: item?.id,
            key: index,
            type: item?.type,
          };
        }
      );
      setListTypeTransaction(convertData);
    }
  }, [typeTransaction]);

  const columns = [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Action",
      dataIndex: "",
      key: "action",
      render: (_: any, record: any) => (
        <Space size="large">
          <span
            className="cursor-pointer hover:underline font-medium"
            onClick={() => {
              {
                setInfoUpdate(record);
                setIsModalOpenUpdate(true);
              }
            }}
          >
            Update
          </span>
          <span
            className="cursor-pointer hover:underline font-medium"
            onClick={() => {
              {
                // setInfoUpdate(record);
                handleDelete(record?.id);
              }
            }}
          >
            Delete
          </span>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Modal
        okButtonProps={{ style: { backgroundColor: "black" } }}
        title="Update Solution"
        open={isModalOpenUpdate}
        onOk={handleOkUpdate}
        onCancel={handleCancelUpdate}
      >
        <div className="flex flex-col gap-4">
          <Input
            onChange={(e) => {
              setType(e.target.value);
            }}
            defaultValue={infoUpdate?.type}
            placeholder="Name Type Transaction"
          />
        </div>
      </Modal>
      <Modal
        okButtonProps={{ style: { backgroundColor: "black" } }}
        title="Create New Solution"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="flex flex-col gap-4">
          <Input
            onChange={(e) => {
              setType(e.target.value);
            }}
            placeholder="Name Type Transaction"
          />
        </div>
      </Modal>
      <div className="max-lg:px-[12px]">
        <div className="flex max-lg:flex-col lg:items-center max-lg:mt-2 justify-between xl:mb-7 lg:mb-5 mb-4">
          <span className="uppercase xl:text-xl text-base font-semibold text-gray-600">
            MANAGE TYPE TRANSACTION
          </span>
          <div>
            <Button
              onClick={showModal}
              color="default"
              variant="solid"
              size="middle"
            >
              <span className=" max-lg:text-sm max-sm:text-xs">
                CREATE TYPE TRANSACTION
              </span>
            </Button>
          </div>
        </div>
        <Table
          dataSource={listTypeTransaction}
          columns={columns}
          pagination={false}
        ></Table>
      </div>
      <FooterFilterMobile></FooterFilterMobile>
    </div>
  );
};

export default TypeTransactionPage;
